// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import type { ReportFormDispatcher } from './useReportForm';
import type { IAPReason } from './IAPReason';
import forLabel from './IAPReason';
import ReportIAPRadio from './ReportIAPRadio';

/**
 * Selecting this option disables the form and dictates the user should navigate to a different page
 */

type Props = {|
  selected: IAPReason | null,
  reason: IAPReason,
  dispatch: ReportFormDispatcher,
  children: React.Node,
|};

const RedirectOption = ({ selected, reason, dispatch, children }: Props) => (
  <ReportIAPRadio
    value={reason}
    selected={selected === reason}
    labelText={forLabel(reason).label}
    onSelect={() => {
      dispatch({ type: 'changeReason', payload: { reason, validator: () => false } });
    }}
  >
    {children}
  </ReportIAPRadio>
);

export default RedirectOption;
